<fw-tooltip [title]="tooltipText">
  <div class="status-chip" [class.failed]="status === statuses.Failed" test-id="status-chip-button">
    <fw-icon class="status-chip-icon" [color]="statusColor">{{statusIcon}}</fw-icon>
    <span class="status-chip-text">{{ title | titlecase }}</span>
  </div>
</fw-tooltip>
